import request from '@/router/axios';

const urlPrefix = process.env.VUE_APP_LOCAL_DEVELOPMENT == 'false' ? '/sys' : '/sys'
//加载数据
export function getloadTaxData(obj) {
  return request({
    url: urlPrefix+'/taxManage/loadTaxData',
    method: 'post',
    params: obj
  });
}
//查询
export function getCostCenterComparisonColumns(obj) {
  return request({
    url: urlPrefix + '',
    method: 'post',
    params: obj
  });
}
//创建批次
export function importExcel(data, params) {
  return request({
    url: urlPrefix + '/taxManage/importExcel',
    method: 'post',
    data,
    params
  });
}
//移除
export function delate(obj) {
  return request({
    url: urlPrefix + '',
    method: 'post',
    params: obj
  });
}